import styled, { css } from 'styled-components';
import {
	media,variables
} from 'styleUtils';

export const Wrapper = styled.div`
  width: 100%;
  height: ${variables.mobileNavHeight}px;
  max-width: 100vw;
  z-index: 600;
  position: relative;
  ${media.smallDesktop`
    height: ${variables.navHeight}px;
  `}
`;

export const NavContainer = styled.nav`
  height: ${variables.mobileNavHeight}px;
  position: fixed;
  width: 100%;
  background-color: transparent;
  transition: all .3s ease;
  z-index: 800;

  ${media.smallDesktop`
    height: ${variables.navHeight}px;
  `}

  ${props => props.scrolled && css`
    transition: all .3s ease;
    background-color: ${variables.white};
    height: ${variables.navHeightScrolled}px;
  `}

  ${props => props.solid && css`
    background-color: ${variables.white};

    ${media.smallDesktop`
      height: ${variables.navHeightScrolled}px;
    `}
  `}
`;

export const LogoContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;

export const Logo = styled.div`
  background-image: url(/static/img/apostrophe/logo-dark.png);
  width: 113px;
  height: 25px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position-y: 50%;

  ${media.smallDesktop`
    height: 50px;
    width: 140px;
  `}
`;

